import { createBlueprint as e } from "@made-people/blueprint";
const n = e({
  slots: {
    closeButton: "top-4 right-4 absolute rounded-full [&>svg]:w-4 [&>svg]:h-4 bg-white flex justify-center items-center z-20 h-8 w-8",
    contentWrapper: "grid-cols-12 grid gap-4 w-full pb-10 lg:py-10 max-w-page-max-w mx-auto",
    drawerWrapper: "max-h-[85vh] overflow-y-scroll relative rounded-lg",
    modalContent: "fixed left-1/2 top-1/2 max-w-[1000px] lg:w-[70vw] lg:max-h-[600px] rounded-lg overflow-y-scroll -translate-x-1/2 -translate-y-1/2 data-[state=open]:animate-contentShow",
    modalOverlay: "fixed inset-0 bg-black/40 data-[state=open]:animate-overlayShow"
  },
  variants: {}
}), i = e({
  slots: {
    base: "grid-cols-12 grid gap-4 w-full pb-10 lg:py-10 max-w-page-max-w mx-auto"
  },
  variants: {}
}), t = e({
  slots: {
    base: "border-b border-border-light",
    trigger: "flex items-center justify-between w-full py-4 lg:py-6 cursor-pointer group/facet-trigger text-left gap-4 px-3 text-heading-2xs lg:text-heading-sm",
    content: "pb-6 px-3 text-body-sm bg-background-surface text-balance -mt-2 lg:-mt-4",
    icon: "w-6 h-6",
    item: "border-b border-gray-200 last:border-b-0",
    header: "flex justify-between items-center text-heading-xl",
    headerWrapper: "flex items-center gap-2 pb-3",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:-rotate-180 group-data-[state=closed]:rotate-0 transition-transform transform w-auto w-3.5 h-3.5 mr-6 flex",
    iconClose: "hidden"
  },
  variants: {}
}), l = e({
  slots: {
    priceWrapper: "flex col-start-2 col-end-4 flex justify-end text-right mb-4 gap-1",
    oldPrice: "text-label-md line-through text-text-less-emphasis-2 flex gap-1",
    price: "text-label-md font-medium data-[is-discounted=true]:text-sale-price flex gap-2",
    name: "col-start-1 col-end-2 text-label-md mb-3.5",
    shortDescription: "text-body-sm col-span-3 md:col-span-12 lg:col-span-3 mb-3 py-6",
    description: "text-body-lg col-span-3  md:col-span-12 lg:col-span-8 max-w-[900px]",
    descriptionLabel: "text-label-md mb-4",
    descriptionReadMoreButton: "text-link text-body-sm mt-2 cursor-pointer",
    brand: "text-body-xs lg:text-body-sm text-text-less-emphasis-1 col-span-3 mb-3",
    productType: "text-label-sm uppercase text-white w-fit p-1 tracking-wide",
    accordionWrapper: "border-t border-gray-200 -ml-3 lg:ml-0 w-[calc(100%+24px)] lg:w-full lg:ml-0 lg:w-full",
    wrapper: "group flex flex-col col-span-12 lg:col-span-6 grid grid-cols-2 gap-x-6 place-start grid-rows-[repeat(10,_min-content)] px-component-x-spacing-sm lg:px-component-x-spacing-lg pb-10"
  },
  variants: {}
}), a = {
  main: l,
  accordion: t.clone()
}, p = e({
  slots: {
    contentWrapper: "flex flex-col gap-3 px-4 lg:min-w-[400px] pb-6 pt-2 lg:px-6",
    priceRow: "flex gap-4 items-center",
    priceValue: "text-label-md font-medium w-16",
    priceLabel: "text-body-sm text-text-less-emphasis-2",
    discountBadge: "text-sale-price text-body-sm",
    trigger: "cursor-pointer fill-text-less-emphasis-2 [&>svg]:fill-[#71717a]"
  },
  variants: {}
}), r = e({
  slots: {
    base: "col-span-12 lg:col-span-8 lg:row-start-1 flex flex-col gap-2 lg:hidden [&>div:empty]:hidden px-3 [--keen-slider-spacing:12px] [--keen-slider-per-view:1] md:[--keen-slider-spacing:24px] lg:[--keen-slider-spacing:20px]",
    galleryWrapper: "flex overflow-hidden relative aspect-product-image overflow-hidden rounded-lg",
    imageWrapper: "aspect-product-image bg-[#F6F6F6] w-[calc((100%-((var(--keen-slider-per-view)-1)*var(--keen-slider-spacing)))/var(--keen-slider-per-view))] shrink-0 overflow-hidden",
    image: "aspect-product-image h-full w-full object-cover cursor-grab active:cursor-grabbing",
    thumbnailWrapper: "hidden",
    dotsIndicatorWrapper: "flex justify-center gap-2 absolute bottom-5 left-5",
    dotsIndicator: "w-[5px] h-[5px] bg-black/40 data-[is-active=true]:bg-black",
    thumbnail: "aspect-square object-cover overflow-hidden lg:rounded-lg h-[48px] !w-[48px] border data-[is-active='true']:border-black/40 border-transparent cursor-pointer transition-colors",
    linkButton: "h-12 absolute bottom-0 left-0 right-0 bg-background-surface-1 text-white text-center",
    numberIndicator: "text-sm text-left bottom-4 left-4 absolute lg:hidden",
    bundleSavingsBadge: "absolute top-4 left-4 text-label-sm",
    arrowsWrapper: "hidden lg:flex justify-between absolute inset-0",
    leftArrow: "absolute top-1/2 left-4 transform -translate-y-1/2",
    rightArrow: "absolute top-1/2 right-4 transform -translate-y-1/2",
    peekingImage: "opacity-50 absolute inset-0 bg-white",
    modelIsWearing: "absolute top-4 left-4 text-label-sm",
    shopTheLook: "absolute bottom-4 left-4 text-label-sm bg-white/90 hover:bg-white px-3 py-2 rounded transition-colors"
  },
  variants: {}
}), d = e({
  slots: {
    trigger: "absolute bottom-4 left-4 text-label-sm bg-white/90 hover:bg-white px-3 py-2 rounded transition-colors flex items-center gap-2 [&_svg]:w-4 [&_svg]:h-4",
    triggerContent: "flex items-center gap-2",
    wrapper: "flex flex-col max-h-[80dvh] lg:max-h-none lg:h-full",
    header: "px-6 py-4 border-b border-gray-200 flex items-center justify-between",
    close: "",
    productList: "flex-1 overflow-y-scroll px-6 py-4 space-y-6"
  },
  variants: {}
}), c = e({
  slots: {
    wrapper: "flex flex-col gap-3 pb-6 border-b border-gray-200 last:border-b-0",
    contentWrapper: "flex gap-4",
    imageWrapper: "flex-shrink-0 w-28 h-28 bg-gray-100 rounded-lg overflow-hidden",
    image: "w-full h-full object-cover",
    info: "flex-1 flex flex-col gap-1",
    productName: "text-body-sm font-medium",
    productType: "text-body-xs text-gray-600",
    priceWrapper: "flex items-center gap-2 mt-1",
    price: "text-body-sm font-medium data-[is-discounted=true]:text-red-600",
    priceBeforeDiscount: "text-body-xs text-gray-500 line-through"
  },
  variants: {}
}), g = e({
  slots: {
    base: "col-span-12 lg:col-span-8 hidden lg:grid grid-cols-12 gap-6 [&>div:empty]:hidden ml-6",
    imageWrapper: "aspect-product-image bg-[#F6F6F6] col-span-6 last:odd:col-span-12 rounded-lg overflow-hidden relative",
    image: "aspect-product-image h-full w-full object-cover",
    modelIsWearing: "absolute top-4 left-4 text-label-sm",
    bundleSavingsBadge: "absolute top-4 right-4 text-label-sm",
    peekingImage: "opacity-50 absolute inset-0 bg-white",
    shopTheLook: "absolute bottom-4 left-4 text-label-sm bg-white/90 hover:bg-white px-3 py-2 rounded transition-colors"
  },
  variants: {}
}), x = e({
  slots: {
    base: "flex flex-col gap-4 w-full col-span-12 lg:col-span-6 px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    heading: "text-label-sm",
    tableWrapper: "flex flex-col gap-2",
    row: "flex justify-between border-b border-gray-25 pb-2 last:border-b-0",
    label: "flex gap-2 text-heading-2xs",
    icon: "",
    value: "text-heading-2xs font-medium text-right"
  },
  variants: {}
}), b = e({
  slots: {
    base: "flex flex gap-6 w-full col-span-12 lg:col-start-8 lg:col-end-13 px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    item: "flex items-start w-20 flex-col gap-2",
    label: "text-heading-2xs",
    bar: "bg-black/10 h-2 w-full rounded-lg",
    barFill: "bg-brand-secondary h-full rounded-lg",
    scoreLabel: "text-body-xs font-secondary"
  },
  variants: {}
}), u = e({
  slots: {
    base: "flex flex-col gap-2 w-full col-span-12 lg:col-start-1 lg:col-end-6 px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    label: "text-heading-2xs",
    tags: "flex flex-wrap gap-2",
    tag: "flex items-center justify-center border border-black/20 rounded px-2 py-2 text-body-2xs uppercase font-secondary"
  },
  variants: {}
}), f = e({
  slots: {
    base: "flex flex-col gap-2 w-full col-span-12 lg:col-start-1 lg:col-end-6 px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    header: "flex items-center justify-between",
    link: "text-link text-body-sm mt-2 cursor-pointer",
    label: "text-heading-2xs",
    icon: "",
    blocks: "flex flex-wrap gap-2",
    block: "flex flex-col gap-3 items-center justify-center",
    description: ""
  },
  variants: {}
}), m = e({
  slots: {
    base: "flex",
    label: "text-heading-2xs font-bold",
    value: "text-body-2xs"
  },
  variants: {}
}), h = e({
  slots: {
    base: "min-w-[400px] col-span-4 gap-1",
    innerWrapper: "bg-gray-25 rounded-md flex justify-between relative px-1 py-2 min-w-[400px] col-span-4 gap-1",
    // Optional Price Tag
    priceTag: "bg-secondary font-bold absolute -top-2 left-2 text-white px-1 rounded-sm rotate-[-2deg]",
    oldPriceTag: "bg-primary font-bold absolute -top-2 left-2 text-white px-1 rounded-sm rotate-[-2deg]",
    // Current Quantity
    currentQuantityWrapper: "flex justify-center items-center flex-1",
    currentQuantityInputWrapper: "flex relative bg-white rounded-lg w-full text-body-sm items-center max-w-[94px]",
    currentQuantityInput: "w-full py-4 px-2 text-body-sm font-[700] appearance-none border-none caret-transparent	!ring-secondary rounded-lg",
    currentQuantityUnit: "absolute right-4 text-body-xs font-bold",
    quantityPickersWrapper: "w-full flex flex-col gap-1 flex-[2]",
    updateButton: "absolute right-4",
    // Quantity Picker
    quantityPickerWrapper: "w-full flex bg-black/5 rounded-full p-1.5 gap-1",
    quantityDisplay: "flex relative max-h-[40px] p-3 bg-white rounded-lg text-body-sm items-center justify-between w-full",
    quantityText: "font-[700] text-body-sm",
    quantityUnit: "font-bold text-body-xs"
  },
  variants: {}
}), w = e({
  slots: {
    base: "col-span-3 md:col-span-12 lg:col-span-3 my-4 gap-2 flex flex-col"
  },
  variants: {}
}), y = e({
  slots: {
    base: "z-30 col-span-3 md:col-span-12 lg:col-span-3 flex flex-col gap-3 pt-4",
    header: "text-label-sm flex justify-between items-center",
    wrapper: "flex w-full gap-2 grid grid-cols-4",
    size: "w-fit group/size h-9 text-label-md col-span-1 bg-background-surface-1 rounded-md w-full flex justify-center items-center text-black data-[is-selected=true]:bg-primary transition-all active:scale-95",
    lowStockIndicator: "w-1 h-1 absolute top-0 right-0 bg-red-500 rounded-full"
  },
  variants: {}
}), v = e({
  slots: {
    trigger: "",
    optionsWrapper: "flex flex-col gap-4",
    wrapper: "gap-4",
    header: "my-4 border-b border-theme-neutral-200 pb-4",
    heading: "text-heading-sm",
    sizeWrapper: "flex flex-wrap gap-2",
    size: "p-2 border border-theme-neutral-200 rounded-full data-[is-selected='true']:bg-black data-[is-selected='true']:text-white disabled:opacity-50"
  },
  variants: {}
}), k = e({
  slots: {
    base: "col-span-3 flex flex-col gap-3 my-3",
    header: "text-label-sm flex justify-between items-center",
    siblingsWrapper: "flex gap-2 flex-wrap",
    sibling: "flex justify-center rounded-lg overflow-hidden data-[is-selected=true]:border data-[is-selected=true]:border-black data-[is-selected=true]:border-solid",
    siblingImage: "w-12 aspect-product-image object-cover"
  },
  variants: {}
}), W = e({
  slots: {
    base: "col-span-3 flex flex-col gap-3 my-8",
    header: "text-label-sm font-medium flex justify-between items-center",
    siblingsWrapper: "flex gap-4 flex-wrap",
    sibling: "w-4 h-4"
  },
  variants: {
    rounded: {
      true: {
        sibling: "rounded-full data-[is-selected=true]:before:rounded-full"
      },
      false: {
        sibling: ""
      }
    },
    outline: {
      true: {
        sibling: "relative border-[1px] border-black/10"
      },
      false: {
        sibling: ""
      }
    },
    activeIndicator: {
      border: {
        sibling: "data-[is-selected=true]:relative data-[is-selected=true]:border-2 data-[is-selected=true]:border-black data-[is-selected=true]:before:absolute data-[is-selected=true]:before:content-[''] data-[is-selected=true]:before:top-0 data-[is-selected=true]:before:left-0 data-[is-selected=true]:before:right-0 data-[is-selected=true]:before:bottom-0 data-[is-selected=true]:before:border-[1px] data-[is-selected=true]:before:border-white"
      },
      underline: {
        sibling: "relative data-[is-selected=true]:after:content-[''] data-[is-selected=true]:after:block data-[is-selected=true]:after:w-full data-[is-selected=true]:after:h-[1.4px] data-[is-selected=true]:after:bg-black data-[is-selected=true]:after:absolute data-[is-selected=true]:after:-bottom-1"
      }
    }
  },
  defaultVariants: {
    activeIndicator: { initial: "underline" },
    rounded: { initial: "false" },
    outline: { initial: "false" }
  }
}), B = e({
  slots: {
    base: "flex flex-col gap-4",
    heading: "text-2xl font-bold",
    wrapper: "grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4"
  },
  variants: {}
}), _ = e({
  slots: {
    base: "fixed data-[is-visible=true]:bottom-5 -bottom-10 left-4 right-4 w-[calc(100%-32px)] lg:right-16 lg:w-max-[360px] lg:left-auto z-50 transition-all duration-[500ms] ease-[linear(0,_0.012_0.9%,_0.049_2%,_0.409_9.3%,_0.513_11.9%,_0.606_14.7%,_0.691_17.9%,_0.762_21.3%,_0.82_25%,_0.868_29.1%,_0.907_33.6%,_0.937_38.7%,_0.976_51.3%,_0.994_68.8%,_1)]",
    buttonsWrapper: "grid grid-cols-2 gap-2 w-full"
  },
  variants: {}
}), j = e({
  slots: {
    base: "col-span-3 flex flex-col gap-4 my-6",
    //Sections Wrapper
    sectionsWrapper: "col-span-3 flex flex-col",
    //Section
    section: "flex flex-col gap-8",
    productName: "text-label-sm font-bold",
    productNameWrapper: "h-[30px] overflow-hidden",
    selectionHeading: "text-label-md font-bold",
    productImage: "aspect-product-image w-[120px] object-cover",
    productWrapper: "flex relative",
    swatchWrapper: "absolute bottom-2 left-2 px-2 py-1 bg-black text-white text-xs rounded-md",
    swatch: "",
    swatchLabel: "text-body-sm",
    productSlider: "flex gap-2",
    link: "hidden",
    // Price Totals
    totalsWrapper: "flex flex-col gap-2",
    totalsRow: "flex justify-between",
    totalsLabel: "text-label-sm",
    totalsValue: "text-label-sm"
  },
  variants: {}
}), T = e({
  slots: {
    base: "p-4 bg-black text-white rounded-md",
    item: "flex",
    label: "text-body-sm"
  },
  variants: {}
}), I = e({
  slots: {
    base: "flex flex-col grid-cols-3 p-6 bg-grey-100 rounded-lg",
    label: "text-heading-2xs",
    bar: "bg-black/10 h-2 w-full rounded-lg",
    dot: "bg-brand-secondary h-full rounded-lg",
    scaleLabel: "text-label-sm",
    scaleLabels: "flex justify-between",
    sizeLabel: "text-label-sm",
    sizeText: "text-body-xs font-secondary"
  },
  variants: {}
}), z = e({
  slots: {
    base: ""
  },
  variants: {}
}), P = e({
  slots: {
    base: "col-span-3 flex flex-col my-6 gap-2",
    contentWrapper: "text-black rounded-md flex gap-0.5 overflow-hidden",
    heading: "text-campaign-text text-heading-md",
    subtitle: "text-body-sm text-campaign-text",
    image: "h-auto w-24 object-cover min-w-24 aspect-product-image",
    textWrapper: "flex flex-col p-5 bg-campaign-bg justify-between gap-6",
    condition: "text-body-xs text-less-emphasis-1"
  },
  variants: {
    theme: {
      primary: {
        textWrapper: "bg-campaign-bg",
        condition: "text-campaign-text",
        heading: "text-campaign-text",
        subtitle: "text-campaign-text"
      },
      secondary: {
        textWrapper: "bg-promotion-bg",
        condition: "text-promotion-text",
        heading: "text-promotion-text",
        subtitle: "text-promotion-text"
      },
      tertiary: {
        textWrapper: "bg-tertiary",
        condition: "text-black",
        heading: "text-black",
        subtitle: "text-black"
      },
      black: {
        textWrapper: "bg-black",
        condition: "text-white",
        heading: "text-white",
        subtitle: "text-white"
      },
      white: {
        textWrapper: "bg-white",
        condition: "text-black",
        heading: "text-black",
        subtitle: "text-black"
      }
    }
  },
  defaultVariants: {
    theme: "primary"
  }
}), S = e({
  slots: {
    contentWrapper: "",
    closeButton: "hidden lg:block"
  },
  variants: {}
}), L = e({
  slots: {
    contentWrapper: "px-6 py-4 grid grid-cols-12"
  },
  variants: {}
}), C = e({
  slots: {
    trigger: "mb-3 mt-2 lg:mt-3"
  },
  variants: {}
}), G = e({
  slots: {
    base: "bg-campaign-bg",
    heading: "text-heading-md",
    text: "text-body-sm"
  },
  variants: {}
}), D = e({
  slots: {
    base: "grid-cols-12 grid w-full pb-10 lg:pb-10 max-w-page-max-w mx-auto",
    detailsWrapper: "px-4 py-6 md:py-4 lg:px-8 grid grid-cols-3 w-full pb-10 col-span-12 md:col-span-12 lg:col-span-4 h-fit w-full [&>*:first-child]:hidden [&>*:first-child]:md:flex lg:sticky lg:top-20 lg:right-0 bg-white/50 backdrop-blur-sm z-10 rounded-lg",
    belowTheFoldDetails: "col-span-12 lg:py-20 flex flex-col gap-6 lg:gap-12 px-3 lg:px-6 lg:col-span-8",
    tagsWrapper: "flex flex-row gap-2 col-span-full flex-wrap mb-3 empty:hidden",
    relatedProductsWrapper: "col-span-12"
  },
  variants: {}
}), A = e({
  slots: {
    base: "grid grid-cols-12",
    relatedProductsWrapper: "lg:bg-background-surface-1 col-span-12 lg:row-start-3 lg:row-end-4 flex flex-col lg:px-component-x-spacing-md lg:-mx-component-x-spacing-md order-1",
    tags: "flex justify-between mb-12 lg:mb-0",
    outOfStock: "text-heading-sm py-6",
    outOfStockIndicator: "rounded-full bg-system-error h-2 w-2 inline-block mr-2",
    discontinued: "text-heading-sm py-6",
    discontinuedIndicator: "rounded-full bg-system-warning h-2 w-2 inline-block mr-2",
    discountinuedBadgeWrapper: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-10",
    attributesWrapper: "col-span-12 lg:col-span-6 lg:row-start-2 lg:row-end-3 flex flex-col lg:px-component-x-spacing-md",
    detailsWrapper: "col-span-12 lg:col-span-6 lg:row-start-2 lg:row-end-3 flex flex-col order-1 lg:-order-1",
    addToCartWrapper: "group flex flex-col col-span-12 lg:col-span-6 lg:sticky lg:bg-white lg:rounded-lg lg:py-4 lg:z-10 lg:h-fit lg:top-6 left-0 right-0 px-component-x-spacing-xs lg:px-component-x-spacing-md pb-10 lg:row-start-1 lg:row-end-2",
    shippingBarometer: ""
  },
  variants: {}
}), F = e({
  slots: {
    base: "grid-cols-12 grid gap-4 w-full pb-10 lg:py-10 max-w-page-max-w mx-auto",
    detailsWrapper: "max-w-6xl mx-16 flex flex-col",
    fitText: "col-span-3 text-body-sm py-1",
    relatedProductsWrapper: "col-span-12"
  },
  variants: {}
}), R = e({
  slots: {
    base: "grid-cols-12 grid gap-4 w-full p-10",
    breadcrumbsWrapper: "col-span-12 py-6 px-6",
    detailsWrapper: "flex flex-col",
    relatedProductsWrapper: "col-span-12",
    attributesWrapper: "col-span-12 flex flex-col gap-1",
    badgesWrapper: "flex absolute top-3 left-3 z-10 gap-2",
    highlightTextWrapper: "text-body-md",
    highlightTextRow: "text-body-md",
    productVideo: "col-span-12 w-full h-auto",
    reviewCarouselWrapper: "col-span-12 mt-10"
  },
  variants: {}
}), q = e({
  slots: {
    base: "grid-cols-12 grid gap-4 w-full pb-10 lg:py-10 max-w-theme-page-max-w mx-auto",
    detailsWrapper: "max-w-6xl mx-16 flex flex-col",
    tagsWrapper: "flex flex-row gap-2",
    relatedProductsWrapper: "col-span-12",
    productId: "col-span-12 text-label-sm text-text-less-emphasis-1",
    retracedIcons: "col-span-12"
  },
  variants: {}
}), o = e({
  slots: {
    base: "grid-cols-12 grid gap-4 w-full p-10 ",
    breadcrumbsWrapper: "col-span-12 py-6 px-6",
    detailsWrapper: "flex flex-col",
    relatedProductsWrapper: "col-span-12",
    returnPolicyWrapper: "col-span-12"
  },
  variants: {
    layout: {
      row: {
        base: "lg:grid-cols-[1fr_2fr]",
        detailsWrapper: "order-2 lg:order-1"
      },
      "row-reverse": {
        base: "lg:grid-cols-[2fr_1fr]",
        detailsWrapper: "order-1 lg:order-2"
      }
    }
  }
}), V = {
  main: o.clone(),
  details: a.main.clone(),
  gallery: r.clone()
};
export {
  L as A,
  S as B,
  C,
  G as D,
  D as E,
  A as F,
  F as G,
  R as H,
  q as I,
  V as J,
  o as K,
  i as a,
  a as b,
  p as c,
  d,
  r as e,
  g as f,
  x as g,
  b as h,
  u as i,
  f as j,
  m as k,
  h as l,
  w as m,
  y as n,
  v as o,
  n as p,
  k as q,
  W as r,
  c as s,
  B as t,
  _ as u,
  j as v,
  T as w,
  I as x,
  z as y,
  P as z
};
//# sourceMappingURL=blueprint-572e03d6.mjs.map
